import { FormEvent } from "react";

import { Search } from "@magnetic/search";

import { HFlex } from "src/components/hFlex";
import { pluralize } from "src/utils/string";

import "./searchWithResultCount.scss";

export interface SearchWithResultCountProps {
  readonly searchTerm: string;
  readonly onSearchChange: (e: FormEvent<HTMLInputElement>) => void;
  readonly placeholder?: string;
  readonly resultCount: number;
  readonly dataQa?: string;
}

export const SearchWithResultCount = (props: SearchWithResultCountProps) => {
  const {
    searchTerm,
    onSearchChange,
    placeholder = "Search",
    resultCount = 0,
    dataQa
  } = props;

  return (
    <HFlex align="center" className="search-with-result-count">
      <Search
        label=""
        data-qa={dataQa}
        onChange={onSearchChange}
        placeholder={placeholder}
        value={searchTerm}
        aria-label={placeholder}
      />
      <div className="result-count" aria-live="polite" aria-atomic="true">
        {resultCount} {pluralize(resultCount, "result", "results")}
      </div>
    </HFlex>
  );
};
